<div class="relative pt-1 md:absolute md:top-9 md:right-6" ucDropdown>
	<button class="flex only-tab-focus align-center">
		<!-- icon on mobile -->
		<uc-three-dots-horizontal-svg
			customStyles="pointer-events-none md:hidden"
			aria-label="More Options"
		/>
		<!-- icon on desktop -->
		<uc-three-dots-vertical-svg />
	</button>
	<div
		class="absolute right-0 z-10 bg-white border rounded-md shadow-xl dropdown-content top-8"
	>
		<button
			(click)="onShowModalPanel('share')"
			class="flex items-center gap-2 px-4 py-2 only-tab-focus"
			aria-label="Share"
		>
			<uc-share-svg />
			Share
		</button>

		<button
			(click)="onShowModalPanel('report')"
			class="flex items-center gap-2 px-4 py-2 only-tab-focus"
			aria-label="Report"
		>
			<uc-exclamation-mark-triangular-svg customStyles="pointer-events-none" />
			Report
		</button>
	</div>
</div>
